import axios from "axios";
import { call, put, takeEvery, select } from "redux-saga/effects";
import constants from "constants";
import actions from "actions";
import { toast } from "react-toastify";
import { push } from "redux-router";
import validator from "services/validator.js";

const {
  addRequestError,
  addErrorsSaga,
  addValidateError,
  cleanErrors,
  startRequest,
  endRequest,
  saveSuperhosts,
  setSuperhost,
} = actions;

const {
  CREATE_SUPERHOST,
  UPDATE_SUPERHOST,
  DELETE_SUPERHOSTS,
  API_ADMIN_SUPERHOSTS,
  GET_SUPERHOST,
  GET_SUPERHOSTS,
} = constants;

const formatRequestData = (superhost) => {
  let data = new FormData();

  Object.keys(superhost).forEach((field) => {
    data.append(`superhost[${field}]`, superhost[field]);
  });
  // data.append('superhost[logo]', superhost.logo)

  return data;
};

const apiCreateSuperhost = (superhost) =>
  axios.post(API_ADMIN_SUPERHOSTS, superhost);

const apiGetSuperhost = (id) => axios.get(`${API_ADMIN_SUPERHOSTS}/${id}`);

const apiGetSuperhosts = (page, query) => {
  const params =
    page === "all"
      ? {}
      : {
          page,
          per_page: 5,
          ...query,
        };

  return axios.get(API_ADMIN_SUPERHOSTS, { params });
};

const apiUpdateSuperhost = (id, superhost) =>
  axios.put(`${API_ADMIN_SUPERHOSTS}/${id}`, superhost);

const apiDeleteSuperhosts = (superhost_ids) => {
  return axios.post(`${API_ADMIN_SUPERHOSTS}/destroy`, {
    superhost_ids: superhost_ids,
  });
};

function* createSuperhost({ superhost }) {
  try {
    if (
      yield select((store) => store.requests.indexOf("superhost_create") != -1)
    )
      return;

    yield put(startRequest("superhost_create"));

    const errors = validator.validate(superhost, "superhost");
    if (errors) {
      yield put(addValidateError(CREATE_SUPERHOST, errors));
      yield put(endRequest("superhost_create"));
      return;
    } else {
      yield put(cleanErrors(CREATE_SUPERHOST));
    }
    const superhostRequestData = yield call(formatRequestData, superhost);
    const response = yield call(apiCreateSuperhost, superhost);
    const createdSuperhost = response.data.superhost;
    toast.success("Superhost successfully created!");
    yield put(push("/superhosts/"));
    yield put(endRequest("superhost_create"));
  } catch (e) {
    yield put(endRequest("superhost_create"));
    yield put(addErrorsSaga(CREATE_SUPERHOST, e.response));
  }
}

function* getSuperhost({ id }) {
  try {
    const response = yield call(apiGetSuperhost, id);
    const superhost = response.data.superhost;
    yield put(setSuperhost(superhost));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* getSuperhosts({ page = 1, query = {} }) {
  try {
    const response = yield call(apiGetSuperhosts, page, query);
    const superhosts = response.data.superhosts;
    const count = response.data.count;
    const totalPages = response.data.total_pages;
    yield put(saveSuperhosts({ superhosts, count, page, totalPages, query }));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* updateSuperhost({ id, superhost }) {
  try {
    const errors = validator.validate(superhost, "superhost");
    if (errors) {
      yield put(addValidateError(UPDATE_SUPERHOST, errors));
      return;
    } else {
      yield put(cleanErrors(UPDATE_SUPERHOST));
    }

    const superhostRequestData = yield call(formatRequestData, superhost);
    const response = yield call(apiUpdateSuperhost, id, superhost);
    toast.success("Superhost successfully updated!");
    yield put(push("/superhosts/"));
  } catch (e) {
    yield put(addErrorsSaga(UPDATE_SUPERHOST, e.response));
  }
}

function* deleteSuperhosts({ superhost_ids }) {
  if (!superhost_ids.length) return;
  const superhostIds = superhost_ids;
  try {
    yield call(apiDeleteSuperhosts, superhostIds);
    toast.success("Superhosts successfully deleted!");
    const query = yield select((state) => state.superhosts.superhosts.query) ||
      {};
    const page = yield select((state) => state.superhosts.superhosts.page) || 1;
    yield call(getSuperhosts, { page, query });
  } catch (e) {
    yield put(addErrorsSaga(DELETE_SUPERHOSTS, e.response));
  }
}

function* __createSuperhost() {
  yield takeEvery(CREATE_SUPERHOST, createSuperhost);
}

function* __getSuperhost() {
  yield takeEvery(GET_SUPERHOST, getSuperhost);
}

function* __getSuperhosts() {
  yield takeEvery(GET_SUPERHOSTS, getSuperhosts);
}

function* __updateSuperhost() {
  yield takeEvery(UPDATE_SUPERHOST, updateSuperhost);
}

function* __deleteSuperhosts() {
  yield takeEvery(DELETE_SUPERHOSTS, deleteSuperhosts);
}

export {
  __createSuperhost,
  __updateSuperhost,
  __deleteSuperhosts,
  __getSuperhosts,
  __getSuperhost,
};



// WEBPACK FOOTER //
// ./src/sagas/admin/superhosts.js